import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Zawodnik from './Zawodnik';
import Elearning from './Elearning';

const root = ReactDOM.createRoot(document.getElementById('root'));
const path = window.location.pathname.toLowerCase();
const isZawodnik = path === '/zawodnik' || path === '/zawodnik/';
const isElearning = path === '/elearning' || path === '/elearning/';

root.render(
  <React.StrictMode>
    {isZawodnik ? <Zawodnik /> : isElearning ? <Elearning /> : <App />}
  </React.StrictMode>
);